import landingPage from "./landingPage.jsx";
import commonAndMisc from "./commonAndMisc.jsx";
import searchStrip from "./searchStrip.jsx";
import forms from "./forms.jsx";
import booking from "./booking.jsx";
import hotels from "./hotels.jsx";
import hotel from "./hotel.jsx";
import product from "./product.jsx";
import tours from "./tours.jsx";
import my_profile from "./my_profile.jsx";
import mainSearchForm from "./mainSearchForm.jsx";
import flights from "./flights.jsx";
import navbar from "./navbar.jsx";
import restaurant from "./restaurant.jsx";
import activity from "./activity.jsx";
import transfers from "./transfers.jsx";
import carRental from "./carRental.jsx";
import rail from "./rail.jsx";
import trains from "./trains.jsx";
import ferries from "./ferries.jsx";
import dynamicPackage from "./dynamicPackage.jsx";
import register from "./register.jsx";

const fr = {
  ...landingPage,
  ...commonAndMisc,
  ...searchStrip,
  ...forms,
  ...booking,
  ...hotels,
  ...hotel,
  ...product,
  ...tours,
  ...my_profile,
  ...mainSearchForm,
  ...flights,
  ...navbar,
  ...restaurant,
  ...activity,
  ...transfers,
  ...carRental,
  ...rail,
  ...trains,
  ...ferries,
  ...dynamicPackage,
  ...register,
};

export default fr;
